export default function (element, data) {
    window.addEventListener("mousemove", function (event) {
        const offset = ((event.pageX / window.innerWidth) * 2 - 1) * -75;
        const backgroundOffset = ((event.pageX / window.innerWidth)) * 100;
        element.style.setProperty('--hands-offset', offset + 'px');
        element.style.setProperty('--background-offset', backgroundOffset + '%');
        
    })
}
